export const UPS = 'UPS';
export const FEDEX = 'FEDEX';
export const MSTORE = 'MSTORE';
export const MSTORE_BY_ZIPCODE = 'MSTORE_BY_ZIPCODE';
export const LABELFREE = 'LABEL-FREE';
export const BSTORE = 'BSTORE';
export const BSTORE_BY_ZIPCODE = 'BSTORE_BY_ZIPCODE';
export const MDROPNGO = 'MDROP-N-GO';
export const BDROPNGO = 'BDROP-N-GO';
export const BTSTORE = 'BTSTORE';
export const FCC_FIELDS = 'id,name,address,locationNumber,storeNumber,phoneNumber,divisionId,schedule,geoLocation,cutOffTime,inventories(inventory(upcNumber,storeInventory(bopsAvailability,bossAvailability,bossAvailabilityMessage,storeAvailability,bopsEligibility))),attributes';
export const AREA_RUG_INFO = 'Your return includes a rug. Please note that rugs can only be returned to eligible Macy’s stores with a rug department.';
export const OPR_DIV_NO_BCOM = 1027;

export const LOCATION_ERROR_DEFAULT_MSG = 'The location you entered is invalid. Please try again.';
export const LOCATION_ERROR_TIMEOUT_MSG = 'We\'re sorry. We\'re currently unable to retrieve your location. Please try again later.';
export const LOCATION_ERROR_NO_RESULTS_MSG_UPS = 'We could not find any UPS locations near you. For more results, please try another city, state, or zip.';
export const LOCATION_ERROR_NOT_ENABLED = 'We\'re currently unable to retrieve your location. Please enable location to see results.';
export const LOCATION_INVALID_ZIPCODE = 'The location you entered is invalid. Please try again.';
export const LOCATION_NOT_FOUND_MESSAGE = 'No stores were found within';
export const LOCATION_ERROR_NO_RESULTS_MSG_FEDEX = (address, radius) => `We can’t find a FedEx location within ${radius} miles of ${address}. For more results, please try another city, state, or zip code.`;

export const ERROR_MESSAGES = {
  [UPS]: LOCATION_ERROR_NO_RESULTS_MSG_UPS,
  [MSTORE]: LOCATION_NOT_FOUND_MESSAGE,
  [BTSTORE]: LOCATION_NOT_FOUND_MESSAGE,
  [LABELFREE]: LOCATION_ERROR_NO_RESULTS_MSG_UPS,
  [BSTORE]: LOCATION_NOT_FOUND_MESSAGE,
  [MDROPNGO]: LOCATION_NOT_FOUND_MESSAGE,
  [BDROPNGO]: LOCATION_NOT_FOUND_MESSAGE,
  [FEDEX]: LOCATION_ERROR_NO_RESULTS_MSG_FEDEX,
  40490: LOCATION_ERROR_DEFAULT_MSG,
};

export const EXCLUDED_LOCATION_IDS = [1834];
